import ShowIf from "../../ShowIf/ShowIfView";
import { get } from "micro-dash";
import styles from "./Block.module.scss";
import i18n from "../../../constants/i18n";
import React from "react";

export const SingleVideo = ({ block }) => (
    <div className="tile is-12 is-parent">
        <div className="tile is-12 is-child">
            <ShowIf condition={get(block, ["video", "fileName"])}>
                <div className={`${styles.videoObject} ${styles.isSingle}`}>
                    <span className="icon is-medium">
                        <i className="fas fa-video fa-lg"></i>
                    </span>
                </div>
            </ShowIf>
            <ShowIf
                condition={
                    !get(block, ["video", "fileName"]) &&
                    !get(block, ["video", "processingFailure"])
                }
            >
                <div className={`${styles.videoObject} ${styles.isSingle}`}>
                    <div className="loader"></div>
                </div>
            </ShowIf>
            <ShowIf
                condition={
                    !get(block, ["video", "fileName"]) &&
                    get(block, ["video", "processingFailure"])
                }
            >
                <div className={`${styles.videoObject} ${styles.isSingle}`}>
                    <span
                        className="icon is-right has-text-danger is-large"
                        title={i18n.generic.processingFailureMessage.replace(
                            "<FILENAME>",
                            block.video.originalFileName
                        )}
                    >
                        <i className="fas fa-times-circle" />
                    </span>
                </div>
            </ShowIf>
        </div>
    </div>
);
